import { render, staticRenderFns } from "./PainerMsgCenter.vue?vue&type=template&id=4fc94872&scoped=true"
import script from "./PainerMsgCenter.vue?vue&type=script&lang=js"
export * from "./PainerMsgCenter.vue?vue&type=script&lang=js"
import style0 from "./PainerMsgCenter.vue?vue&type=style&index=0&id=4fc94872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc94872",
  null
  
)

export default component.exports